import React, { Component } from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import * as StyledComponent from '../styles'
import MultiLineTitle from './MultiLineTitle.js'
import QuantitySelection from './QuantitySelection'
import formatCurrency from '../helpers/formatCurrency'
import ColorOptionLabel from './ColorOptionLabel'
import FallbackImage from './FallbackImage'
import ItemError from './ItemError'
import Config from '../configs'

class CartItem extends Component {
  componentDidMount() {
    this.checkItemHasError()
  }

  checkItemHasError = () => {
    const { max_qty, sku_data = {} } = this.props
    if (sku_data.not_allow_to_checkout) {
      this.props.setInlineErrorMsg(sku_data.id, {
        message: I18n.t('errors.not_allow_to_checkout')
      })
    } else if (sku_data.stock_level < sku_data.quantity) {
      this.props.setInlineErrorMsg(sku_data.id, {
        message: sku_data.stock_level === 0
          ? I18n.t('errors.out_of_stock')
          : I18n.t('errors.not_enough_stock')
      })
    } else if (sku_data.quantity > max_qty) {
      this.props.setInlineErrorMsg(sku_data.id, {
        message: I18n.t('errors.max_qty_reached', { max_qty })
      })
    }
  }

  render() {
    const { sku_data = {}, error = {}, max_qty } = this.props
    const {
      id,
      stock_level,
      image = '',
      title = '',
      color_name = '',
      size_name = '',
      hide_color_option = true,
      swatch = '',
      hex_value = '',
      sell_price = 0,
      quantity = 1,
      not_allow_to_checkout = false,
    } = sku_data
    const subtotal = sell_price * quantity
    const { message = '', code: error_code } = error
    const color_option_label_name = _.trim(`${!!color_name && color_name !== '-' ? color_name : ''} ${!hide_color_option ? '/' : ''} ${size_name}`)

    return <StyledComponent.CartItem>
      {
        <div className='cart-item-row'>
          <div className='product-image-container'>
            <FallbackImage
              className='product-image'
              fallback_className='product-image-default'
              src={image}
              alt=''
            />
          </div>
          <div className='product-details'>
            <div
              className='remove-btn'
              alt=''
              onClick={this.props.removeItem.bind(this, id)}
            />
            <div className='product-name'>
              { Config.get('DEBUG') && `[${id}]`}
              <MultiLineTitle title = {title} />
            </div>
            {
              (!hide_color_option || !_.isEmpty(size_name)) && <ColorOptionLabel swatch={swatch} name={color_option_label_name} hex_value={hex_value} />
            }
            <div className='quantity-row'>
              <QuantitySelection
                quantity={quantity}
                onChange={this.props.onQuantityChange.bind(this, id)}
                max_qty={max_qty}
                increase_disabled={error_code === 30201 || error_code === 30202 || stock_level < quantity}
                decrease_disabled={error_code === 30202}
              />
              {
                sell_price > 0 &&
                  <span className='item-price' >HK{formatCurrency(sell_price)}</span>
              }
            </div>
            <div className='subtotal-price'>HK{formatCurrency(subtotal)}</div>
          </div>
          { message && <ItemError error_message={message} /> }
        </div>
      }
    </StyledComponent.CartItem>
  }
}

export default CartItem



// WEBPACK FOOTER //
// ./src/components/CartItem.js